// click version
// class AlgoliaCustomAtc extends HTMLElement {
//   constructor() {
//     super()

//     this.open = false
//     this.hasFetched = false
//     // waiting for next tick since data is not available right away???
//     setTimeout(() => {
//       this.btn = this.querySelector('[data-quick-add-btn]')
//       this.loadTo = this.querySelector('[data-custom-quick-add-options-container]')
//       // this.fetchMarkup(this.dataset.product)
//       this.initEvents()
//     }, 0)
//   }

//   initEvents() {
//     if (this.btn) {
//       this.btn.addEventListener('click', this.handleClickEvent.bind(this))
//     }
//   }

//   handleClickEvent(e) {
//     e.preventDefault()
//     e.stopPropagation()

//     if (!this.hasFetched) {
//       this.fetchMarkup()
//     } else {
//       this.toggleQuickAdd()
//     }
//   }

//   toggleQuickAdd() {
//     if (this.open) {
//       this.loadTo.classList.add('hidden')
//       this.open = false
//     } else {
//       this.loadTo.classList.remove('hidden')
//       this.open = true
//     }
//   }

//   fetchMarkup() {
//     this.toggleQuickAdd()
//     // console.log('fetching markup - ', this.dataset.product)
//     fetch(`/products/${this.dataset.product}?sections=algolia-product-card-quick-add`)
//       .then(response => {
//         return response.json()
//       })
//       .then((data) => {
//         this.renderMarkup(data['algolia-product-card-quick-add'], this.loadTo)
//         this.hasFetched = true
//       })
//   }

//   renderMarkup(html, el) {
//     const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
//     el.innerHTML = parsedHTML.getElementById('shopify-section-algolia-product-card-quick-add').innerHTML
//     setTimeout(() => {
//       this.initVariantClickHandlers(el)
//     }, 0)
//   }

//   initVariantClickHandlers(html) {
//     const variants = html.querySelectorAll('[data-variant-id]')
//     variants.forEach(v => {
//       v.addEventListener('click', this.handleVariantClick.bind(this))
//     })
//   }

//   handleVariantClick(e) {
//     e.preventDefault()
//     e.stopPropagation()

//     // console.log('time to add this to cart via cart method on window - ', e.target.dataset.variantAvailable)

//     if (window.__theme.addToCart && e.target.dataset.variantAvailable === 'true') {
//       window.__theme.addToCart({
//         items: [
//           {
//             id: e.target.dataset.variantId,
//             quantity: 1
//           }
//         ]
//       })
//     } else {
//       console.log('out of stock so ignoring click')
//     }
//   }
  
// }

// customElements.define('algolia-custom-quick-add', AlgoliaCustomAtc);
// hover version
class AlgoliaCustomAtc extends HTMLElement {
  constructor() {
    super()
    this.open = true
    this.hasFetched = false
    
    setTimeout(() => {
      this.btn = this.querySelector('[data-quick-add-btn]')
      this.loadTo = this.querySelector('[data-custom-quick-add-options-container]')
      this.fetchMarkup()
    }, 0)
  }

  fetchMarkup() {
    this.loadTo?.classList?.remove('hidden')
    
    fetch(`/products/${this.dataset.product}?sections=algolia-product-card-quick-add`)
      .then(response => response.json())
      .then((data) => {
        this.renderMarkup(data['algolia-product-card-quick-add'], this.loadTo)
        this.hasFetched = true
      })
  }

  renderMarkup(html, el) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    if (el) {
      el.innerHTML = parsedHTML?.getElementById('shopify-section-algolia-product-card-quick-add').innerHTML
    }

    setTimeout(() => {
      this.initShowMoreHandler()
      this.initVariantClickHandlers(el)
    }, 0)
  }

  initShowMoreHandler() {
    const showMoreButton = this.querySelector('[data-show-more-variants]')
    const hiddenVariants = this.querySelectorAll('.max-md\\:hidden')
    
    if (showMoreButton && hiddenVariants.length > 0) {
      showMoreButton.addEventListener('click', () => {
        hiddenVariants.forEach(variant => variant.classList.remove('max-md:hidden'))
        showMoreButton.remove()
      })
    }
  }

  initVariantClickHandlers(html) {
    const variants = html?.querySelectorAll('[data-variant-id]')
    variants?.forEach(v => {
      v.addEventListener('click', this.handleVariantClick.bind(this))
    })
  }

  handleVariantClick(e) {
    e.preventDefault()
    e.stopPropagation()

    if (window.__theme.addToCart && e.target.dataset.variantAvailable === 'true') {
      window.__theme.addToCart({
        items: [
          {
            id: e.target.dataset.variantId,
            quantity: 1
          }
        ]
      })
    } else {
      console.log('out of stock so ignoring click')
    }
  }
}

customElements.define('algolia-custom-quick-add', AlgoliaCustomAtc);